import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, HStack, Modal, ModalBody, ModalCloseButton, ModalContent, ModalHeader, ModalOverlay, mode, useColorMode } from '@abb/uikit';
import useEmblaCarousel from 'embla-carousel-react';
import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { pxToRem } from 'utils/pxToRem';
import { Slider } from './Slider';
export function TutorialModal(param) {
    let { onClose, isOpen, videoData } = param;
    const { colorMode } = useColorMode();
    const { t } = useTranslation('common');
    const [disabled, setDisabled] = useState(0);
    const [emblaRef, emblaApi] = useEmblaCarousel();
    const videos = useMemo(()=>{
        var _videoData_filter_, _videoData_filter;
        return videoData ? videoData === null || videoData === void 0 ? void 0 : (_videoData_filter = videoData.filter((item)=>`/${item.type.toLowerCase()}` === location.pathname)) === null || _videoData_filter === void 0 ? void 0 : (_videoData_filter_ = _videoData_filter[0]) === null || _videoData_filter_ === void 0 ? void 0 : _videoData_filter_.links : [];
    }, [
        location.pathname
    ]);
    return /*#__PURE__*/ _jsxs(Modal, {
        isCentered: true,
        isOpen: isOpen,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx(ModalOverlay, {}),
            /*#__PURE__*/ _jsxs(ModalContent, {
                maxW: "608px",
                borderRadius: "24px",
                children: [
                    /*#__PURE__*/ _jsx(ModalHeader, {
                        p: `${pxToRem(16)} ${pxToRem(16)} ${pxToRem(16)} ${pxToRem(20)}`,
                        children: t('tutorial.title')
                    }),
                    /*#__PURE__*/ _jsx(ModalCloseButton, {
                        bg: mode('#EDEDED', 'rgba(41, 41, 41, 0.9)')({
                            colorMode
                        }),
                        mt: pxToRem(6),
                        w: pxToRem(30),
                        h: pxToRem(30),
                        mr: pxToRem(3)
                    }),
                    /*#__PURE__*/ _jsxs(ModalBody, {
                        p: "24px",
                        children: [
                            /*#__PURE__*/ _jsx(Box, {
                                overflow: "hidden",
                                mb: 6,
                                children: /*#__PURE__*/ _jsx(Slider.Wrapper, {
                                    emblaRef: emblaRef,
                                    overflow: 'unset',
                                    children: /*#__PURE__*/ _jsx(Slider.Container, {
                                        width: "100%",
                                        children: videos === null || videos === void 0 ? void 0 : videos.map((video, index)=>/*#__PURE__*/ _jsx(Slider.Item, {
                                                width: "100%",
                                                children: /*#__PURE__*/ _jsx(Box, {
                                                    as: "iframe",
                                                    width: {
                                                        base: '100%',
                                                        md: '560px'
                                                    },
                                                    height: "315px",
                                                    src: video,
                                                    title: "YouTube video player",
                                                    allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share",
                                                    referrerPolicy: "strict-origin-when-cross-origin",
                                                    allowFullScreen: true,
                                                    borderRadius: "16px"
                                                })
                                            }, index))
                                    })
                                })
                            }),
                            (videos === null || videos === void 0 ? void 0 : videos.length) > 1 && /*#__PURE__*/ _jsxs(HStack, {
                                justify: "space-between",
                                gap: 2,
                                display: {
                                    base: 'none',
                                    md: 'flex'
                                },
                                children: [
                                    /*#__PURE__*/ _jsx(Slider.PrevButton, {
                                        onClick: ()=>{
                                            emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollPrev();
                                            setDisabled(disabled - 1);
                                        },
                                        isDisabled: disabled === 0
                                    }),
                                    /*#__PURE__*/ _jsx(Slider.NextButton, {
                                        onClick: ()=>{
                                            emblaApi === null || emblaApi === void 0 ? void 0 : emblaApi.scrollNext();
                                            setDisabled(disabled + 1);
                                        },
                                        isDisabled: disabled === (videos === null || videos === void 0 ? void 0 : videos.length) - 1
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
